import React from 'react';
import Button from '../Form/Button';
import Lottie from 'lottie-react';
import success from '../../constants/success.json';
import { InfoModal } from './InfoModal';

type Props = {
  title: string;
  onProccessClick: () => void;
  className?: string;
  buttonText?: string;
};

export default function SuccessModal({
  title,
  onProccessClick,
  className = 'w-[20%]',
  buttonText = 'Proceed'
}: Readonly<Props>) {
  return (
    <InfoModal width={className} className="h-fit rounded-md p-4">
      <div className="flex flex-col items-center justify-between bg-white font-circular text-2xl font-bold text-[#353535]">
        <p className="my-5 text-center text-base">{title}</p>
        <Lottie animationData={success} style={{ height: 200, width: 300 }} />
        <div className="flex items-center">
          <Button
            variant="primary"
            size="md"
            className="mb-3 w-[10rem] rounded px-[1.5rem] py-1 text-sm font-normal"
            label={buttonText}
            onClick={onProccessClick}
          ></Button>
        </div>
      </div>
    </InfoModal>
  );
}
